import type { Editor } from '@tiptap/react';
import { fixTables } from '@tiptap/pm/tables';

const TABLE_DEBUG = import.meta.env.DEV;

const debugLog = (label: string, payload?: Record<string, unknown>) => {
  if (!TABLE_DEBUG) return;
  const w = window as Window & { __TABLE_DEBUG_LOGS__?: Array<Record<string, unknown>> };
  const entry: Record<string, unknown> = {
    at: new Date().toISOString(),
    label,
    ...(payload ? { payload } : {}),
  };
  if (!w.__TABLE_DEBUG_LOGS__) w.__TABLE_DEBUG_LOGS__ = [];
  w.__TABLE_DEBUG_LOGS__.push(entry);
  if (w.__TABLE_DEBUG_LOGS__.length > 500) {
    w.__TABLE_DEBUG_LOGS__.splice(0, w.__TABLE_DEBUG_LOGS__.length - 500);
  }

  if (payload) {
    // eslint-disable-next-line no-console
    console.log(`[TableDebug] ${label}`, payload);
  } else {
    // eslint-disable-next-line no-console
    console.log(`[TableDebug] ${label}`);
  }
};

/**
 * tiptap Table command의 fixTables()는 내부에서 tr를 dispatch하지 않으므로
 * 여기서 직접 트랜잭션을 dispatch해 즉시 테이블 구조를 보정한다.
 */
export function forceFixTables(editor: Editor) {
  const tr = fixTables(editor.state);
  if (!tr) {
    debugLog('force-fix-tables:no-transaction');
    return;
  }
  debugLog('force-fix-tables:dispatch', {
    stepsLength: tr.steps.length,
    selectionFrom: tr.selection.from,
    selectionTo: tr.selection.to,
  });
  tr.setMeta('addToHistory', false);
  editor.view.dispatch(tr);
}

export function scheduleForceFixTables(editor: Editor) {
  // 삽입 직후 + 다음 프레임에 한 번 더 보정 (초기 렌더 타이밍 이슈 완화)
  debugLog('schedule-force-fix-tables');
  requestAnimationFrame(() => {
    debugLog('schedule-force-fix-tables:raf-1');
    forceFixTables(editor);
    requestAnimationFrame(() => {
      debugLog('schedule-force-fix-tables:raf-2');
      forceFixTables(editor);
    });
  });
}
